import { mapActions } from 'vuex';

const promptMessageMixin = {
  methods: {
    ...mapActions([
      'updateMessageResponse',
    ]),
    mixinShowMessage(message, action = 'push') {
      this.updateMessageResponse(message);
      const route = {
        name: 'PromptMessage',
      };
      if (action === 'replace') {
        this.$router.replace(route);
        return;
      }
      this.$router.push(route);
    },
  },
};

export default promptMessageMixin;
